export default {
	title: "Attendance Options",
	subtitle: "Configure complaints and resources for this attendance type",
	label: "Name",
	categories: {
		COMPLAINT: "Complaint",
		RESOURCE: "Resource",
	},
	fieldTypes: {
		CHECKBOX: "Checkbox",
		CHECKBOX_WITH_TEXT: "Checkbox with text",
		QUANTITY: "Quantity",
	},
	form: {
		label: {
			label: "Option Name",
			placeholder: "E.g.: Respiratory issue, Candles",
			hint: "Name that will appear on the ticket",
		},
		category: {
			label: "Category",
			hint: "Complaint: what will be treated. Resource: what will be used.",
		},
		fieldType: {
			label: "Field Type",
			hint: "How the attendant will fill this option on the ticket",
		},
	},
	create: "Add Option",
	edit: "Edit Option",
	delete: "Delete Option",
	deleteConfirmation: "Are you sure you want to delete the option \"{label}\"?",
	messages: {
		created: "Option \"{label}\" created successfully",
		updated: "Option \"{label}\" updated successfully",
		deleted: "Option \"{label}\" deleted successfully",
		loadError: "Error loading options",
		createError: "Error creating option",
		updateError: "Error updating option",
		deleteError: "Error deleting option",
	},
	empty: {
		title: "No options configured",
		text: "Add complaints and resources that can be selected when issuing tickets of this attendance type",
	},
	tabs: {
		complaints: "Complaints",
		resources: "Resources",
	},
	ticket: {
		sectionTitle: "Attendance Options",
		complaints: "Complaints",
		resources: "Resources",
		customTextPlaceholder: "Describe...",
		quantityLabel: "Qty",
		topComplaint: "Top complaint",
	},
	validation: {
		labelRequired: "Name is required",
		categoryRequired: "Category is required",
	},
};
